/* GiornoGaming — micro-interazioni globali (leggero, nessuna dipendenza) */
(function () {
  // Stato "scrolled" per l'ombra dell'header sticky.
  var ticking = false;
  function updateScrolled() {
    document.documentElement.classList.toggle('gg-scrolled', window.scrollY > 8);
    ticking = false;
  }
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateScrolled);
      }
    },
    { passive: true }
  );
  updateScrolled();
})();
